import {Component, OnInit, OnDestroy} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {UserOptionsService} from '../service/userOptions.service';
import {Subscription} from 'rxjs/Subscription';
import {Router} from '@angular/router';
import {UserContext, User, BaseComponent, EnterCause} from '../core/core.component';
import {SelectItem} from 'primeng/primeng';

declare var $: any;

@Component({
  selector: 'app-access-options',
  templateUrl: './access-options.component.html',
  styleUrls: ['./access-options.component.css'],
})
export class UserOptionsComponent extends BaseComponent implements OnInit, OnDestroy {
  static DIALOG_ID = 'UserAccessOptionsDialog';
  private subscriptions: Subscription[] = [];

  user: User = null;
  userContext: UserContext;
  elements: EnterCause[] = [];
  loading = false;
  options: SelectItem[] = [];
  elementId: number = null;


  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userOptionsService: UserOptionsService) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnDestroy() {
    if (this.subscriptions != null) {
      for (let i = 0; i < this.subscriptions.length; ++i) {
        this.subscriptions[i].unsubscribe();
      }
    }
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.subscriptions[0] = this.userOptionsService.getUserOptionsComponentStatus().subscribe(
        user => {
          if (user != null) {
            this.user = user;
            $('#' + UserOptionsComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
            this.loadUserOptions();
            this.loadOptSelected();
          } else {
            this.close();
          }
        }
      );
    }
  }

  private loadUserOptions() {
    this.options = [];
    this.userOptionsService.getOptions(this.userContext.srmToken, this.user.id).subscribe(
      result => {
        const userOpts = result.enterCauses;
        for (let i = 0; i < userOpts.length; ++i) {
          const current: EnterCause = userOpts[i];
          this.options.push({label: current.description, value: current.id});
        }
      },
      error => {
        this.handleError(error);
      });
  }

  private loadOptSelected() {
    this.elements = [];
    this.loading = true;
    this.userOptionsService.getOptUser(this.userContext.srmToken, this.user.id).subscribe(
      result => {
        this.elements = result.enterCauses;
        this.loading = false;
      },
      error => {
        this.handleError(error);
        this.loading = false;
      });
  }

  deleteSelectedOpt(opt: EnterCause) {
    if (opt == null) {
      return;
    }
    this.userOptionsService.deleteUserOptions(this.userContext.srmToken, this.user.id, opt.id).subscribe(
      result => {
        this.elements.splice(this.elements.indexOf(opt), 1);
        this.loadUserOptions();
      },
      error => {
        this.handleError(error);
      }
    );
  }

  insertOpt() {
    if (this.elementId) {
      this.userOptionsService.insertUserOptions(this.userContext.srmToken, this.user.id, this.elementId).subscribe(
        result => {
          this.elementId = null;
          this.loadUserOptions();
          this.loadOptSelected();
        },
        error => {
          this.handleError(error);
        }
      );
    }
  }

  close() {
    $('#' + UserOptionsComponent.DIALOG_ID).modal('hide');
    this.user = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/access-options/access-options.component.ts